import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { numberOnly } from "../bin/common";
import { useMutation } from "@tanstack/react-query";
import { smsCert, smsSend, updatePassword } from "../library/api";

const FindPw = () => {
  const navigate = useNavigate();

  const [isChangePw, setIsChangePw] = useState(false);
  const [value, setValue] = useState({
    id: "",
    phoneNum: "",
    certNum: "",
    password: "",
    password2: "",
  });
  const [valueCheck, setValueCheck] = useState({
    phoneNum: false,
    certKey: false,
  });
  const regeId = /^(?=.*[A-Za-z0-9])[A-Za-z0-9]{4,20}$/;
  const regEmail =
    /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
  const regpassword =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?])[A-Za-z\d!@#$%^&*()_+[\]{};':"\\|,.<>/?]{8,16}$/;
  // 문자 전송
  const { mutate: smsSendMutate } = useMutation({
    mutationFn: smsSend,
    mutationKey: ["smsSend"],
    onSuccess: (data) => {
      if (data.done) {
        alert("인증번호가 전송되었습니다");
        setValueCheck((prevState) => ({
          ...prevState,
          phoneNum: true,
          certKey: false,
        }));
        setTimeout(() => {
          if (valueCheck.certKey === false) {
            setValue((prevState) => ({ ...prevState, certNum: "" }));
            setValueCheck((prevState) => ({
              ...prevState,
              phoneNum: false,
              certKey: false,
            }));
          }
        }, 180000);
      }
    },
    onError: (error) => {
      alert(error.response.data.message);
      throw error;
    },
  });

  // 문자 인증번호 인증
  const { mutate: smsCertMutate } = useMutation({
    mutationFn: smsCert,
    mutationKey: ["smsCert"],
    onSuccess: (data) => {
      if (data.done) {
        alert("인증이 완료 되었습니다");
        setValueCheck((prevState) => ({ ...prevState, certKey: true }));
        return;
      }
    },
    onError: (error) => {
      alert(error.response.data.message);
      if (error.response.data.code === 406) {
        setValue((prevState) => ({ ...prevState, certNum: "" }));
        // setValueCheck(prevState => ({...prevState, phoneNum: false, certKey: false}));
      }

      throw error;
    },
  });
  // 문자 인증번호 인증
  const { mutate: updatePasswordMutate } = useMutation({
    mutationFn: updatePassword,
    mutationKey: ["updatePassword"],
    onSuccess: (data) => {
      if (data.done === true) {
        alert("변경 완료 했습니다.");
        navigate("/login");
        return;
      } else {
        alert("비밀번호 변경에 실패했습니다.");
        window.location.reload();
        navigate("/login");
        return;
      }
    },
    onError: (error) => {
      alert(error.response.data.message);
      throw error;
    },
  });

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!value.id) {
      alert("아이디를 입력해주세요");
      return;
    }
    if (!regeId.test(value.id)) {
      alert("아이디가 올바르지 않습니다.");
      return;
    }
    // if (!value.name) {
    //     alert('이름을 입력해주세요');
    //     return;
    // }

    if (!value.phoneNum) {
      alert("휴대폰 번호를 입력해주세요");
      return;
    }

    if (!valueCheck.phoneNum) {
      alert("휴대폰 번호 인증해주세요");
      return;
    }
    if (!value.certNum) {
      alert("인증번호를 입력해주세요");
      return;
    }
    if (value.certNum.length < 6) {
      alert("인증번호를 확인해주세요");
      return;
    }

    if (!valueCheck.certKey) {
      alert("인증번호를 인증해주세요");
      return;
    }

    setIsChangePw(true);
  };

  const handleChangeSubmit = (event) => {
    event.preventDefault();
    if (!regpassword.test(value.password)) {
      alert("비밀번호를 확인해주세요");
      return;
    }
    if (!regpassword.test(value.password2)) {
      alert("비밀번호를 확인해주세요");
      return;
    }
    if (!value.password || !value.password2) {
      alert("비밀번호를 입력해주세요");
      return;
    }

    if (value.password !== value.password2) {
      alert("비밀번호가 일치하지 않습니다.");
      return;
    }

    const items = {
      phoneNum: value.phoneNum,
      certNum: value.certNum,
      id: value.id,
      password: value.password,
    };
    updatePasswordMutate(items);
  };
  return (
    <main className="flex-grow container mx-auto px-4 py-10 sm:py-20">
      {!isChangePw ? (
        <div className="max-w-md mx-auto">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-center mb-2">
            비밀번호 재설정
          </h1>
          <p className="text-center text-sm mb-8 sm:mb-10">
            비밀번호를 재설정 위해 회원정보를 입력해주세요.
          </p>
          <form
            id="pwnForm"
            className="flex flex-col items-center mb-6"
            onSubmit={handleSubmit}
          >
            <div className="mb-2.5 w-full">
              <input
                type="text"
                placeholder="아이디"
                maxLength={20}
                className="w-full px-4 py-3 sm:py-4 border border-gray-300 rounded-lg outline-none"
                onChange={(e) => {
                  setValue((prevState) => ({
                    ...prevState,
                    id: e.target.value,
                  }));
                }}
              />
              {!regeId.test(value.id) && (
                <p className="text-[#F22F2F] text-sm font-medium mt-3 mb-4">
                  아이디를 정확히 입력해주세요.
                </p>
              )}
            </div>

            <div className="mb-2.5 w-full">
              <div className="flex gap-x-[10px]">
                <input
                  type="text"
                  placeholder="휴대폰번호"
                  maxLength="12"
                  onChange={(event) => {
                    numberOnly(event);
                    setValue((prevState) => ({
                      ...prevState,
                      phoneNum: event.target.value,
                      certNum: "",
                    }));
                    setValueCheck((prevState) => ({
                      ...prevState,
                      phone: false,
                      certKey: false,
                    }));
                  }}
                  className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none"
                />
                <button
                  type="button"
                  className={`w-40  text-white py-4 rounded-lg ${
                    valueCheck.phoneNum ? "bg-regal-blue" : "bg-teal-500"
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!value.phoneNum) {
                      alert("휴대폰 번호를 입력해주세요");
                      return;
                    }
                    smsSendMutate(value.phoneNum);
                  }}
                >
                  인증번호 전송
                </button>
              </div>
            </div>
            <div className="mb-14 w-full">
              <div className="flex gap-x-[10px]">
                <input
                  type="text"
                  placeholder="인증번호 6자리를 입력해주세요"
                  value={value.certNum}
                  maxLength="6"
                  onChange={(event) => {
                    numberOnly(event);
                    setValue((prevState) => ({
                      ...prevState,
                      certNum: event.target.value,
                    }));
                    setValueCheck((prevState) => ({
                      ...prevState,
                      certKey: false,
                    }));
                  }}
                  className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none"
                />
                <button
                  type="button"
                  className={`w-40  text-white py-4 rounded-lg ${
                    valueCheck.certKey ? "bg-regal-blue" : "bg-teal-500"
                  } `}
                  onClick={(e) => {
                    e.preventDefault();

                    if (!value.phoneNum) {
                      alert("휴대폰 번호를 입력해주세요");
                      return;
                    }

                    if (!valueCheck.phoneNum) {
                      alert("휴대폰 번호를 인증해주세요");
                      return;
                    }
                    if (!value.certNum) {
                      alert("인증번호를 입력해주세요");
                      return;
                    }
                    if (value.certNum.length < 6) {
                      alert("인증번호를 확인해주세요");
                      return;
                    }
                    smsCertMutate({
                      phone_numb: value.phoneNum,
                      cert_numb: value.certNum,
                    });

                    // setValueCheck(prevState => ({...prevState, certKey: true}));
                  }}
                >
                  인증하기
                </button>
              </div>
            </div>
            <button
              type="submit"
              className="w-full bg-teal-500 font-extrabold text-lg text-white py-3 sm:py-4 rounded-full hover:bg-teal-600 transition duration-300"
            >
              비밀번호 재설정
            </button>
          </form>
          <div className="flex justify-between items-center">
            <p className="mt-1 text-base font-medium">아이디를 찾으시나요?</p>
            <button
              type="button"
              className="px-3 py-2 border border-gray-400 rounded-lg text-base font-medium text-gray-400"
              onClick={() => navigate("/find-id")}
            >
              아이디 찾기
            </button>
          </div>
        </div>
      ) : (
        <div className="max-w-md mx-auto">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-center mb-2">
            비밀번호 변경
          </h1>
          <p className="text-center text-sm mb-8 sm:mb-10">
            고객님의 소중한 정보를 보호하기 위하여 <br />
            새로운 비밀번호로 변경 후 서비스를 이용해 주세요.
          </p>
          <form
            id="pwChangeForm"
            className="flex flex-col items-center mb-6"
            onSubmit={handleChangeSubmit}
          >
            <div className="mb-2.5 w-full">
              <input
                type="password"
                placeholder="영문, 숫자, 특수문자를 포함한 8~16자리"
                value={value?.password}
                className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none "
                onChange={(e) => {
                  setValue((prevState) => ({
                    ...prevState,
                    password: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="mb-14 w-full">
              <input
                type="password"
                placeholder="비밀번호 확인"
                value={value?.password2}
                className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none"
                onChange={(e) => {
                  setValue((prevState) => ({
                    ...prevState,
                    password2: e.target.value,
                  }));
                }}
              />
              {value.password2 !== value.password && (
                <p className="text-[#F22F2F] text-sm font-medium mt-1 float-left">
                  비밀번호가 일치하지 않습니다.
                </p>
              )}
            </div>
            <button
              type="submit"
              className="w-full bg-teal-500 font-extrabold text-lg text-white py-3 sm:py-4 rounded-full hover:bg-teal-600 transition duration-300"
            >
              비밀번호 변경
            </button>
          </form>
        </div>
      )}
    </main>
  );
};

export default FindPw;
